import { useQuery } from 'react-query'
import { toast } from 'react-toastify'
import { axios } from 'lib'
import { PaginatedParams, PaginatedResponse } from 'services/api/types'
import { OrderSellers } from 'modules/orders/types'

const loadOrderSellers = (
  params: PaginatedParams
): PaginatedResponse<OrderSellers> => {
  const { page = 1, limit = 10 } = params

  return axios.get('/orders/sellers', {
    params: {
      page,
      limit,
      ...params
    }
  })
}

export function useLoadOrderSellers(params: PaginatedParams) {
  return useQuery(['orderSellers', params], () => loadOrderSellers(params), {
    keepPreviousData: true,
    onError: () =>
      toast.error('Não foi possível carregar vendedores', {
        toastId: 'loadOrdersCustomers'
      })
  })
}
